/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: batch-checkin-component.ts
 *
 * Created by randysorensen on 1/18/18.
 */

function BatchCheckinController(
    this: JS5Object,

    // external deps
    _: JS5Object,
    $q: JS5Object,

    // internal deps
    ModalService: JS5Object,
    PackageService: JS5Object,
    FileUploadService: JS5Object,
) {

    const showMessageModal = (title: string, message: any, resultHandler: JS5Function): void => {
        const messageModalOpts = {
            messageText: message,
            pullCancelLeft: true,
            title: title,
            showOK: true,
            okText: 'Close',
            showCancel: false,
            windowClass: 'message-modal-sm',
        };
        ModalService.showMessageModal(messageModalOpts, resultHandler);
    };

    this.onUploadProgress = (progress: number): void => {
        // The uploader will give us a progress percentage; once
        // the files have been uploaded, we're only half-done
        // as we still need to call the check-in API.
        this.progress = progress / 2;
    };

    const resetUploader = () => {
        this.filesWithErrors = 0;
        this.progress = 0;
        this.resultsDict = {};
        FileUploadService.resetUploader();
    };

    this.onFilesUploaded = (uploadedFiles: JS5Object[]): void => {
        let checkinPromises: JS5Object[] = [];

        _.forEach(uploadedFiles, (file: JS5Object): void => {
            let checkinPromise = PackageService.remoteCheckIn(file.remotePath, true)
            .then((): void => {
                // success
                this.resultsDict[file.name] = ['All packages were successfully imported.'];
            })
            .catch((response: JS5Object): void => {
                // fail
                this.resultsDict[file.name] = response.data;
                ++(this.filesWithErrors);
            })
            .finally((): void => {
                // regardless
                this.progress += 50 / uploadedFiles.length;
            });

            checkinPromises.push(checkinPromise);
        });

        $q.all(checkinPromises).then((): void => {
            if (this.filesWithErrors > 0) {
                ModalService.showCheckinResultModal(this.resultsDict, resetUploader);
            } else {
                showMessageModal('Success', 'All packages were successfully imported.', resetUploader);
            }
        });
    };

    this.onUploaderInitialized = () => {
        resetUploader();
    };


    //=========//
    // Toolbar //
    //=========//

    this.toolbarButtonDefs = [
        {
            label: 'Upload',
            enabled: (): boolean => FileUploadService.canUpload(),
            icon: 'fa-upload',
            onClick: () => {
                FileUploadService.beginUpload();
            },
        },
        {
            label: 'Reset',
            enabled: (): boolean => FileUploadService.canReset(),
            icon: 'fa-undo',
            onClick: () => {
                FileUploadService.resetUploader();
            },
        },
    ];

}

angular
.module('prism-ui.dashboard.checkin')
.component('batchCheckin', {
    templateUrl: 'dashboard/packageCheckin/components/views/batchCheckIn/batch-checkin-template.html',
    controller: BatchCheckinController,
    bindings: {
    },
});

// (EOF)
